import { useMemo } from 'react'

import { ColorSelector as LMFColorSelector } from '@syconium/little-miss-figgy'

import { ProductColor } from '../../../../../types/graphql'
import { ErrorMessage, Label, SelectedOptionText } from '../../shared-form-styles'

const colorMap: Record<string, ProductColor> = {
  Black: {
    hexCodes: ['000'],
    availability: '',
    handle: 'black',
    name: 'Black',
    rawName: 'Black',
  },
  White: {
    hexCodes: ['fff'],
    availability: '',
    handle: 'white',
    name: 'White',
    rawName: 'White',
  },
}

export const ColorSelector: React.FC<{
  disabled?: boolean
  errorMessage?: string
  onSelectColor(colorName: string): void
  selectedColorKey: string | undefined
  label: string
  colorNames: string[]
}> = ({ disabled, errorMessage, onSelectColor, selectedColorKey, label, colorNames }) => {
  const colors = useMemo(
    () => colorNames.filter(name => colorMap[name]).map(name => colorMap[name]!),
    [colorNames]
  )

  return (
    <>
      <Label disabled={disabled ?? false}>
        {label}{' '}
        <SelectedOptionText disabled={disabled ?? false}>{selectedColorKey}</SelectedOptionText>
      </Label>

      <LMFColorSelector
        colors={colors}
        disabled={disabled ?? false}
        onSelectColor={color => onSelectColor(color.name)}
        selectedColorKey={selectedColorKey}
      />

      {errorMessage && <ErrorMessage role='alert'>{errorMessage}</ErrorMessage>}
    </>
  )
}
